export function handleClickNote(event: MouseEvent) {
  const target = event.target as HTMLElement | null;
  if (!target) return;

  const notaSuper = target.closest(".nota-super") as HTMLElement | null;

  if (!notaSuper) return;

  let nextElement = notaSuper.nextElementSibling as HTMLElement | null;

  while (nextElement) {
    if (nextElement.classList?.contains("nota-texto")) {
      nextElement.classList.toggle("oculto");
      break;
    }
    nextElement = nextElement.nextElementSibling as HTMLElement | null;
  }
}
